import { GenericAPIException } from '@reward-platform/shared-api/exceptions/GenericAPIException'
import { MissingEnvVariableException } from '@reward-platform/shared-api/exceptions/MissingEnvVariableException'
import { IncomingMessage, ServerResponse } from 'http'
import { NextApiRequest, NextApiResponse } from 'next'
import { FeatureFlagKey } from '@reward-platform/devcycle'
import { DevCycleEvent } from '~/schemas/featureFlags'
import { devcycleApiClient } from './devcycle.client'
import {
  DevCycleFeatureResponseMap,
  DevCycleTrackResponse,
  DevCycleVariableResponseMap,
} from './devcycle.types'
import { getDevcycleUserFromRequest } from './devcycle.utils'

export const getDevCycleHeaders = () => {
  const serverKey = process.env.DEVCYCLE_SERVER_KEY
  if (!serverKey) {
    throw new MissingEnvVariableException('DEVCYCLE_SERVER_KEY')
  }

  return {
    authorization: serverKey,
  }
}

export const getAllFeatureVariablesForUser = async (
  req: IncomingMessage,
  res: ServerResponse<IncomingMessage>
) => {
  const user = await getDevcycleUserFromRequest(req, res)

  try {
    const response = await devcycleApiClient.post<DevCycleVariableResponseMap>('/variables', user, {
      headers: getDevCycleHeaders(),
    })
    return response.data
  } catch (error: any) {
    throw new GenericAPIException(error)
  }
}

export const getFeatureVariableForUser = async (
  req: IncomingMessage,
  res: ServerResponse<IncomingMessage>,
  featureKey: FeatureFlagKey,
  defaultValue = false
) => {
  const user = await getDevcycleUserFromRequest(req, res)

  try {
    const response = await devcycleApiClient.post<DevCycleVariableResponseMap>('/variables', user, {
      headers: getDevCycleHeaders(),
    })
    return response.data[featureKey]?.value ?? defaultValue
  } catch (error: any) {
    throw new GenericAPIException(error)
  }
}

export const getAllFeaturesForUser = async (req: NextApiRequest, res: NextApiResponse) => {
  const user = await getDevcycleUserFromRequest(req, res)

  try {
    const response = await devcycleApiClient.post<DevCycleFeatureResponseMap>('/features', user, {
      headers: getDevCycleHeaders(),
    })
    return response.data
  } catch (error: any) {
    throw new GenericAPIException(error)
  }
}

export const track = async (req: NextApiRequest, res: NextApiResponse, events: DevCycleEvent[]) => {
  const user = await getDevcycleUserFromRequest(req, res)
  try {
    const response = await devcycleApiClient.post<DevCycleTrackResponse>(
      '/track',
      { user, events },
      { headers: getDevCycleHeaders() }
    )

    return response.data
  } catch (error: any) {
    throw new GenericAPIException(error)
  }
}
